import { assignments } from "@otto-ec/global-resources/onex";
import { submitToExactag } from "./core/execute";

const CRITEO_ONEX_ID = "E3864";

export const appendCriteoData = () => {
  assignments.sub((a)=> {
    const criteoOnexAssignment = a?.[CRITEO_ONEX_ID];
    criteoOnexAssignment &&
      submitToExactag({
        ti: CRITEO_ONEX_ID,
        tg: criteoOnexAssignment,
      });
  });
};
